import Model from "./base/model";

class Anticipation extends Model{
  resourceName() {
    return "anticipations";
  }

  fields() {
    return {
      faturas: {jsonApi: "hasMany", type: "faturas"},
      quotation: {jsonApi: "hasOne", type: "quotations"},
      total_value: "",
      is_blocked: "",
      service_nfes: {jsonApi: "hasMany", type: "nfes"},
    }
  }

  async create(id) {
    return this.request(
      this.resourceName() + "/" + id,
      "POST",
      {},
      {}
    );
  }

  async deleteFatura(id) {
    return this.request(
      this.resourceName() + "/fatura/" + id,
      "DELETE",
      {},
      {},
    )
  }

  async quotationReady(id) {
    return this.request(
      this.resourceName() + "/ready/" + id,
      "POST",
      {},
      {},
    )
  }

  async verify(data) {
    return this.request(
      this.resourceName() + "/verify", 
      "POST", 
      {},
      data, 
    )
  }
}

export default new Anticipation();
